import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuxiliaryPump from "../components/auxiliary-Pump";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const AuxilaryPumpLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [pump_Data, set_Pump_Data] = useState([]);

  const GET_SHIP_PUMP_LISTS = async (ship_Id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_Id);
      post(ApiURL.list_ship_pump_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_Pump_Data(res?.response_data);
        }
      });
    } catch (error) {
      set_loader(false);
      console.error("Error Pump list:", error);
    }
  };

  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    GET_SHIP_PUMP_LISTS(ship_id);
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {pump_Data?.length > 0 ? (
              <>
                {pump_Data?.map((_items) => (
                  <>
                    <AuxiliaryPump eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryPumpLog;
